import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from './core/Navbar';
import Footer from './core/Footer';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPost = async () => {
      try {
        const res = await fetch(`/blog/posts/${slug}.html`);
        if (!res.ok) throw new Error('Post not found');
        const text = await res.text();
        setContent(text);
      } catch (err) {
        console.error('Error loading post:', err);
        setError('Could not load post.');
      }
    };

    loadPost();
  }, [slug]);

  return (
    <>
      <Navbar />
      <div 
        className="blog-banner"
        style={{ backgroundImage: 'url(/assets/journey_cropped.png)' }}
      >
        <div className="banner-overlay">
          <div className="banner-content">
            <a href="/blog" className="back-link">← Back to Blog</a>
          </div>
        </div>
      </div>
      <main className="max-w-4xl mx-auto px-4 py-8">
        {error && <div className="text-red-500 text-center">{error}</div>}
        {!content && !error && <div className="text-gray-500 text-center">Loading...</div>}
        {content && (
          <div className="blog-post">
            <article className="post-content" dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        )}
      </main>
      <Footer />
    </>
  );
};

export default BlogPost;
